import React from 'react';
import './App.css';

import Pathfinder from "./Components/Pathfinder/Pathfinder";

function App() {
  return (
    <Pathfinder />
  );
}

export default App;
